'use client';
import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const LinkContext = createContext(null);
const LinkProvider = ({
  CustomLink,
  children
}) => /* @__PURE__ */ jsx(LinkContext.Provider, { value: CustomLink, children });

export { LinkContext, LinkProvider };
//# sourceMappingURL=LinkContext.js.map
